module.exports = __webpack_public_path__ + "static/media/buttetin_format_11.decf61a4.png";